import React from 'react';
import { Box, Container, LinearProgress } from '@material-ui/core';
import OttSportList from './components/OTTSportList';
import useOTTAdsStore from './store/useOTTAdsStore';
import { ConfigLevel } from '../../../API/OttAds/types';
import useOttAds from '../../../customHooks/OttAds/useOttAds';
import OTTAdsToggle from './components/OTTAdsToggle';
import UploadAdForm from './components/UploadAdForm';
import OttAdsTable from './components/OttAdsTable';

const OttAds = () => {
  const { selectedCategory } = useOTTAdsStore();
  const {
    ottAdsConfig,
    isLoading,
    toggleEnabled,
    createNewAd,
    toggleAdVisible,
    updateAdCTA,
    deleteAd,
    submitting,
    reorderAds,
  } = useOttAds(selectedCategory, ConfigLevel.SPORT);

  return (
    <Box>
      <LinearProgress
        color="secondary"
        style={{ opacity: isLoading || submitting ? 1 : 0 }}
      />

      <Box
        p={3}
        style={{
          pointerEvents: isLoading ? 'none' : 'all',
        }}
      >
        <OttSportList />

        <Box mt={3} />

        {ottAdsConfig && (
          <Container maxWidth="md">
            <Box display="flex" flexDirection="column" style={{ gap: 10 }}>
              <OTTAdsToggle
                enabled={ottAdsConfig.is_enabled}
                onChange={enabled => toggleEnabled(enabled)}
              />

              <UploadAdForm handleUpload={createNewAd} />

              <OttAdsTable
                adsData={ottAdsConfig.ads_data}
                handleToggleVisible={toggleAdVisible}
                updateAdCTA={updateAdCTA}
                deleteAd={deleteAd}
                ads_order_ids={
                  ottAdsConfig.ads_order_ids.length <
                  Object.keys(ottAdsConfig.ads_data).length
                    ? Object.keys(ottAdsConfig.ads_data)
                    : ottAdsConfig.ads_order_ids
                }
                reorderAds={reorderAds}
              />
            </Box>
          </Container>
        )}
      </Box>
    </Box>
  );
};

export default OttAds;
